import React from 'react';
import { bool, string, func } from 'prop-types';
import { Link } from 'react-router-dom';
import AddAddress from 'components/Address/AddAddress';
import urls from 'constants/urls';
import { ArrowLeft } from '@johnlewispartnership/wtr-ingredients/foundations/icons';
import { TextLink } from '@johnlewispartnership/wtr-ingredients/ingredients/TextLink';
import styles from '../ChooseAddressModal.scss';

const AddAddressView = ({
  addAddressTitle = 'Add Address',
  navigateBack = true,
  ukOnlyAddress = false,
  onAfterSubmit,
  manualOnly = true,
}) => {
  return (
    <section className={styles.crudForm} data-test="add-address">
      {navigateBack && (
        <TextLink
          className={styles.backLink}
          component={Link}
          componentProps={{ to: { hash: urls.addressModals.choose } }}
          data-webviewid="back-link"
          underline="always"
        >
          <ArrowLeft />
          Back
        </TextLink>
      )}
      <AddAddress
        onAfterSubmit={onAfterSubmit}
        pageTitle={addAddressTitle}
        ukOnlyAddress={ukOnlyAddress}
        manualOnly={manualOnly}
      />
    </section>
  );
};

AddAddressView.propTypes = {
  onAfterSubmit: func.isRequired,
  addAddressTitle: string,
  navigateBack: bool,
  ukOnlyAddress: bool,
  manualOnly: bool,
};

export default AddAddressView;
